import { cB as e, insideModal as i, c as r, insidePopover as n, cE as o } from "./ghl-ui.es384.js";
const t = e("avatar", `
 width: var(--n-merged-size);
 height: var(--n-merged-size);
 color: #FFF;
 font-size: var(--n-font-size);
 display: inline-flex;
 position: relative;
 overflow: hidden;
 text-align: center;
 border: var(--n-border);
 border-radius: var(--n-border-radius);
 --n-merged-color: var(--n-color);
 background-color: var(--n-merged-color);
 transition:
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
`, [i(r("&", "--n-merged-color: var(--n-color-modal);")), n(r("&", "--n-merged-color: var(--n-color-popover);")), r("img", `
 width: 100%;
 height: 100%;
 `), o("text", `
 white-space: nowrap;
 display: inline-block;
 position: absolute;
 left: 50%;
 top: 50%;
 `), e("icon", `
 vertical-align: bottom;
 font-size: calc(var(--n-merged-size) - 6px);
 `), o("text", "line-height: 1.25")]);
export {
  t as default
};
